module.exports = __webpack_public_path__ + "media/images/survey-bg-6c101eb7ff4603df3952adc485960935.jpg";